import request from '@/plugin/axios'

export function GetAllUser(data) {
	return request({
		url: '/GetAllUser',
		method: 'post',
		data: data
	})
}

export function GetUserByID(data) {
	return request({
		url: '/GetUserByID',
		method: 'post',
		data: data
	})
}

export function GetUserRoles(data) {
	return request({
		url: '/GetUserRoles',
		method: 'post',
		data: data
	})
}


export function AddUser(data) {
	return request({
		url: '/AddUser',
		method: 'post',
		data: data
	})
}

export function UpdateUser(data) {
	return request({
		url: '/UpdateUser',
		method: 'post',
		data: data
	})
}

export function DeleteUsers(data) {
	return request({
		url: '/DeleteUsers',
		method: 'post',
		data: data
	})
}

export function UpdateUserPasswordByID(data) {
	return request({
		url: '/UpdateUserPasswordByID',
		method: 'post',
		data: data
	})
}

export function UpdateMyPassword(data) {
	return request({
		url: '/UpdateMyPassword',
		method: 'post',
		data: data
	})
}

export function UpdateUserByID(data) {
	return request({
		url: '/UpdateUserByID',
		method: 'post',
		data: data
	})
}

export function DeleteUser(data) {
	return request({
		url: '/DeleteUser',
		method: 'post',
		data: data
	})
}

export function GetAllUserOption(data) {
	return request({
		url: '/GetAllUserOption',
		method: 'post',
		data: data
	})
}

export function UpdateUsersAuth(data) {
	return request({
		url: '/UpdateUsersAuth',
		method: 'post',
		data: data
	})
}



